const STAGGER_STEP_MS = 80;
const STAGGER_CAP = 5;

function revealImmediately(elements) {
	elements.forEach((el) => el.classList.add('is-visible'));
}

function assignStaggerDelays() {
	document.querySelectorAll('[data-reveal-group]').forEach((group) => {
		const items = group.querySelectorAll(':scope > [data-reveal]');
		items.forEach((item, index) => {
			const step = Math.min(index, STAGGER_CAP);
			item.style.setProperty('--reveal-delay', `${step * STAGGER_STEP_MS}ms`);
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll('[data-reveal]');
	if (!elements.length) {
		return;
	}

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		revealImmediately(elements);
		return;
	}

	assignStaggerDelays();

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}
				entry.target.classList.add('is-visible');
				obs.unobserve(entry.target);
			});
		},
		{ threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
	);

	elements.forEach((el) => observer.observe(el));
});
